import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useOutOfStorageSpaceAcknowledgement } from '@/atoms'
import { selectStorageSpaceData } from '@/features/domain/order'
import { selectTerritoryId } from '@/features/domain/territory'
import { selectUserConfiguration, isGpsOnly } from '@/features/domain/user'

export function useShowOutOfStorageSpaceModal() {
  const storageData = useSelector(selectStorageSpaceData)
  const territoryId = useSelector(selectTerritoryId)
  const userConfiguration = useSelector(selectUserConfiguration)
  const gpsOnlyUser = useSelector(isGpsOnly)

  const OutOfStorageAcknoledgmentKey = useMemo(() => {
    if (!territoryId) return ''
    return userConfiguration?.planType === 'simulation'
      ? `${territoryId}-${userConfiguration.planId}`
      : `${territoryId}-operations`
  }, [territoryId, userConfiguration])

  const [
    outOfStorageSpaceAcknowledged,
    setOutOfStorageSpaceAcknowledgement,
    clearAllOutOfStorageSpaceAcknowledgements,
  ] = useOutOfStorageSpaceAcknowledgement(OutOfStorageAcknoledgmentKey)

  useEffect(() => {
    if (!territoryId) {
      clearAllOutOfStorageSpaceAcknowledgements()
    }
  }, [territoryId, clearAllOutOfStorageSpaceAcknowledgements])

  useEffect(() => {
    if (storageData.currentOrders < storageData.totalOrders && outOfStorageSpaceAcknowledged) {
      setOutOfStorageSpaceAcknowledgement(false)
    }
  }, [storageData, outOfStorageSpaceAcknowledged, setOutOfStorageSpaceAcknowledgement])

  const isStorageExceeded = useMemo(() => {
    if (userConfiguration.planType === 'archived') return false
    if (gpsOnlyUser) return false

    return territoryId
      ? storageData.currentOrders >= storageData.totalOrders && !outOfStorageSpaceAcknowledged
      : false
  }, [territoryId, storageData, outOfStorageSpaceAcknowledged, userConfiguration, gpsOnlyUser])

  return {
    isStorageExceeded,
    acknowledgeModal: () => setOutOfStorageSpaceAcknowledgement(true),
  }
}
